<template>
  <div>
    <b-modal :ref="`newRiderModal${index}`" @cancel="closeRiderModal" @ok="confirmAddRider" :title="$t('general.notification')">
      <div class="my-4">
        <h5 v-html="notificationContent"></h5>
      </div>
      <b-alert :show="modalAlertCd" dismissible variant="danger" @dismissed="modalAlertCd=0">{{$t('general.updateError')}}</b-alert>
    </b-modal>
    <b-row align-v="center">
      <b-col cols="1">{{index}}.</b-col>
      <b-col cols="5">
        <FITAutoSearch :disabled="permissionLevel>3.5" :label="$t('osm.contents.lifePolicy.generalInformation.productName')" :width="9" v-model="selectedProduct" :rule="{ required:true}" dest=option v-bind="productAutoSearchParams"></FITAutoSearch>
        <!-- <b-row v-if="isCreated">
          <b-col cols="3">{{$t('osm.contents.lifePolicy.generalInformation.productName')}}</b-col>
          <b-col cols="9">{{bilingualProductName}}</b-col>
        </b-row> -->
      </b-col>
      <b-col cols="4">
        <FITTextInput :disabled="permissionLevel>3.5" :rule="{ decimal:true}" :label="$t('osm.contents.lifePolicy.generalInformation.riders.riderPremium')" :width="8" v-model="riderInfo.riderPremium" type="number"></FITTextInput>
        <!--  <b-row v-if="isCreated">
          <b-col cols="4">{{$t('osm.contents.lifePolicy.generalInformation.riders.riderPremium')}}</b-col>
          <b-col cols="8">$ {{riderInfo.riderPremium | money}}</b-col>
        </b-row> -->
      </b-col>
      <b-col cols="2">
        <b-btn variant="primary" :disabled="!riderValidation" @click="onClickAddRider">{{$t('general.add')}}</b-btn>
        <!-- <b-btn variant="danger" @click="onClickRemoveRider" v-if="isCreated">{{$t('general.remove')}}</b-btn> -->
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITTextInput, FITSelect, FITAutoSearch, FITModal } from '@/components'
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue'
export default {
  name: 'RiderRow',
  props: {
    index: {
      type: Number,
      default: 0
    },
    bus: {
      type: Vue,
      required: true
    }
  },
  filters: {
    money: function(val) {
      if (val.length > 0) {
        return '$ ' + val
      }
      return 'N/A'
    }
  },
  methods: {
    closeRiderModal() {
      this.$refs['newRiderModal' + this.index].hide();
    },
    onClickAddRider() {
      Vue.set(this, 'notificationContent', this.$t('osm.contents.general.addRiderConfirm', {
        name: this.selectedProduct.productEnglishName + '(' + this.selectedProduct.productChineseName + ')'
      }));

      this.$refs['newRiderModal' + this.index].show();
    },
    onClickRemoveRider() {
      Vue.set(this, 'notificationContent', this.$t('osm.contents.general.removeRiderConfirm', {
        name: this.selectedProduct.productEnglishName + '(' + this.selectedProduct.productChineseName + ')'
      }));
      this.$refs['newRiderModal' + this.index].show();
    },
    confirmAddRider(evt) {
        if(this.okDisabled)  return;
      this.okDisabled =true;
      evt.preventDefault();
      Vue.set(this.riderInfo, 'policyID', this.policyID);
      this.$store.dispatch('LifePolicy/addLifeRider', this.riderInfo).then((data) => {
        this.bus.$emit('updateRiderSuccess', {
          remove: false,
          ID: data,
          productID: this.selectedProduct.ID,
          riderPremium: this.riderInfo.riderPremium
        });
        Vue.set(this, 'riderInfo', {});
        Vue.set(this, 'selectedProduct', { ID: -1 });
        this.okDisabled =false;
        this.closeRiderModal();
      }).catch((error) => {
        this.okDisabled =false;
        this.showModalAlert();
      });
    },
    showModalAlert() {
      this.modalAlertCd = this.dismissSecs;
    }
  },
  data() {
    return {
      riderInfo: {},
      selectedProduct: { ID: -1 },
      productAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: "life" }],
        showItems: ['productEnglishName', 'productChineseName'],

      },
      notificationContent: this.$t('osm.contents.general.addRiderConfirm'),
      modalAlertCd: 0,
      dismissSecs: 3,
      okDisabled:false,      
    }
  },
  computed: {
        permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    riderValidation(){
      let rider = this.riderInfo;
      if(!rider.productID){
        return false;
      }
      if(!rider.riderPremium){
        return false;
      }
      return true;
    },
    ...mapState({
      workflowCurrentIndex: state => state.LifePolicy.newLife.workflowCurrentStep,
      policyID: state => state.LifePolicy.newLife.policyID,
    }),
    ...mapGetters("LifePolicy", [
      'getTranslatedPolicyFields'
    ]),
    locale() {
      return this.$i18n.locale;
    },
    bilingualProductName() {
      var name = this.productName.english;
      if (this.productName != null && this.productName.chinese.length > 0) {
        name = name + '(' + this.productName.chinese + ")"
      }
      return name.length > 2 ? name : 'N/A';
    }
  },
  watch: {
    policyID(newData, oldData) {
      Vue.set(this.riderInfo, 'policyID', newData);
    },
    selectedProduct(newData, oldData) {
      Vue.set(this.riderInfo, 'productID', newData.ID);
    }
  },
  components: {
    FITFormCard,
    FITTextInput,
    FITSelect,
    FITAutoSearch,
    FITModal
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/components/LifePolicyDetail/RiderRow.vue